<template>
  <div class="multiple-choice-field col-12 mb-3">
    <div class="row no-gutters">
      <div class="col-12 col-xl-6">
        <table v-if="hasOptions" class="w-100 mb-3">
          <thead>
            <tr>
              <th class="col-correct">Correct</th>
              <th class="col-answer">Answer</th>
              <th class="col-remove">&nbsp;</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="id in Object.keys(options)" :key="id">
              <td class="col-correct">
                <div class="custom-control custom-radio">
                  <input
                    type="radio"
                    :id="id"
                    class="custom-control-input"
                    v-model="answer"
                    :value="id"
                  />
                  <label :for="id" class="custom-control-label"></label>
                </div>
              </td>
              <td class="col-answer">
                <Field type="text" v-model="options[id]" />
              </td>
              <td class="col-remove pl-3">
                <a href="#" @click.prevent="removeOption(id)">
                  <icon icon="plus" class="remove-icon" />
                </a>
              </td>
            </tr>
          </tbody>
        </table>
        <a class="btn btn-info" href="#" @click.prevent="addOption()">Add Another Choice</a>
      </div>
    </div>
  </div>
</template>

<script>
import Str from "helpers/Str";
export default {
  props: {
    field: { type: Object, required: true }
  },
  data() {
    return {
      options: {},
      answer: null,
      pausePropagation: false
    };
  },
  watch: {
    field(val) {
      console.log("field updated...");
      this.init();
    },
    options(val) {
      console.log("options updated...");
      if (!this.pausePropagation) {
        this.$emit("update:options", this.options);
      }
    },
    answer(val) {
      console.log("answer updated...");
      if (!this.pausePropagation) {
        this.$emit("update:answer", this.answer);
      }
    }
  },
  computed: {
    hasOptions() {
      return !_.isEmpty(this.options);
    }
  },
  methods: {
    init() {
      this.options = this.field.options || {};
      this.answer = this.field.answer || null;
      // console.log(this.options);
      if (!this.hasOptions) {
        this.options = {
          [Str.random()]: "",
          [Str.random()]: ""
        };
      }
    },
    addOption() {
      let options = this.options;
      options[Str.random()] = "";
      this.options = {};
      this.options = options;
    },
    removeOption(id) {
      let options = this.options;
      delete options[id];
      this.options = {};
      this.options = options;
      if (!this.hasOptions) {
        this.options = {
          [Str.random()]: "",
          [Str.random()]: ""
        };
      }
    }
  },
  created() {
    this.init();
  }
};
</script>